import Vue from 'vue'
import App from './App.vue'
import router from './router'
import NotificationPlugin from './notification'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPen,
  faTrash,
  faSort,
  faSortUp,
  faSortDown,
  faCheck,
  faTimes,
  faSync,
  faCircleNotch,
  faHome,
  faPlus,
  faList,
  faUser,
  faSignOutAlt,
  faSearch,
  faChevronRight,
  faChevronLeft
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { i18next } from './loc'
import VueI18Next from '@panter/vue-i18next'

import './styles.scss'
import './registerServiceWorker'

library.add(faPen, faTrash, faSort, faSortUp, faSortDown, faCheck, faTimes, faSync, faCircleNotch, faHome, faPlus, faList, faUser, faSignOutAlt, faSearch, faChevronLeft, faChevronRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.config.performance = process.env.NODE_ENV !== 'production'

Vue.use(NotificationPlugin)
Vue.use(VueI18Next)

const i18n = new VueI18Next(i18next)

new Vue({
  router,
  render: h => h(App),
  i18n
}).$mount('#app')
